"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReportsTableDefaultSort = [{
        dataField: 'submissionTime',
        order: 'desc'
    }];
//# sourceMappingURL=ReportsTableDefaultSort.js.map